module.exports = __webpack_public_path__ + "img/caret-down.73eeed5d.svg";